import { createRouter, createWebHashHistory } from 'vue-router';

import { routes } from './routes';

import { loadScript, removeScript } from '@/utils/scriptLoader';

export { routes };

const router = createRouter({
	history: createWebHashHistory(),
	routes,
});

const XSOLLA_SCRIPT_URL =
	'//cdn.xsolla.net/payments-bucket-prod/embed/1.5.4/widget.min.js';
const XSOLLA_SCRIPT_ID = 'xsolla-widget-script';

router.beforeEach(async (to, from, next) => {
	document.title = to.meta.title ?? '';

	if (to.meta.requiresXsolla) {
		await loadScript(XSOLLA_SCRIPT_URL, XSOLLA_SCRIPT_ID);
	}

	// Clean up: Remove Xsolla script when leaving a route that required it
	if (!to.meta.requiresXsolla && from.meta.requiresXsolla) {
		removeScript(XSOLLA_SCRIPT_ID);
	}

	next();
});

export default router;
